import * as React from 'react';
const Store = ({ fillPath, ...restProps }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...restProps}>
    <mask
      id="a"
      width={28}
      height={28}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#7E7E7E" d="M0 0h28v28H0z" />
    </mask>

    <path
      fill={fillPath || '#003594'}
      d="M7.359 25.083c-.59 0-1.088-.204-1.497-.612a2.036 2.036 0 0 1-.612-1.497V9.692c0-.589.204-1.088.612-1.496a2.036 2.036 0 0 1 1.497-.613h2.266v-.291c0-1.209.427-2.24 1.281-3.094.854-.854 1.885-1.281 3.094-1.281 1.209 0 2.24.427 3.094 1.28.854.855 1.28 1.886 1.28 3.095v.291h2.267c.59 0 1.088.205 1.496.613.409.408.613.907.613 1.496v13.282c0 .59-.204 1.088-.613 1.497a2.035 2.035 0 0 1-1.496.612H7.359Zm0-1.75h13.282c.09 0 .172-.037.247-.112a.343.343 0 0 0 .112-.247V9.692a.343.343 0 0 0-.112-.246.343.343 0 0 0-.247-.113h-2.266v2.625a.847.847 0 0 1-.251.624.847.847 0 0 1-.624.251.847.847 0 0 1-.624-.25.847.847 0 0 1-.251-.625V9.333h-5.25v2.625a.847.847 0 0 1-.251.624.847.847 0 0 1-.624.251.847.847 0 0 1-.624-.25.847.847 0 0 1-.251-.625V9.333H7.359a.343.343 0 0 0-.247.113.343.343 0 0 0-.112.246v13.282c0 .09.037.172.112.247a.343.343 0 0 0 .247.112Zm4.016-15.75h5.25v-.291c0-.732-.255-1.352-.764-1.861A2.533 2.533 0 0 0 14 4.667c-.732 0-1.352.254-1.861.764-.51.509-.764 1.13-.764 1.86v.292Z"
    />
  </svg>
);
export default Store;
